<template>
  <div style="height: 100%">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.4" :split_setting2="0.65">
      <template #main>
        <TableMain name="one table" ref="RouteTable1" :fields="fields1" :title="table_title.title1" :show_query_container="true"
          :show_toolbar_container="true" :show_toolbar_state="false" :show_pagination_container="true" :show_date_picker="false"
          :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label" :query_button_label="query_lable" :isBusy="isBusy"
          :hb_table_class="'hb_table_route_class1'" @on_query="on_query" @state_change="state_change1" :show_toolbar_button="[0, 0, 1, 1, 1]"
          @current_changed="current_changed" @on_cell_button_click="on_cell_click_route_table1">
          <template #query>
            <el-input clearable size="small" style="width: 300px" placeholder="请输入物料编号、工艺路线名称（或编号）" v-model="RouteSearchText"></el-input>
          </template>
          <template #toolbar>
            <el-button type="info" plain @click="createRoute()" class="ml-2 iconfont icon-add-new" size="mini"> {{$t("common.new")}}
            </el-button>
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain name="one table" ref="RouteTable2" :fields="fields2" :title="table_title.title2" :show_query_container="false"
          :show_toolbar_container="true" :show_pagination_container="true" :show_toolbar_state="false" :show_date_picker="false"
          :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label" :query_button_label="query_lable" :isBusy="isBusyRoute"
          :loading_width="30" :table_height_adjust="8" @state_change="state_change2" :show_toolbar_button="[0, 0, 0, 0, 1]"
          @current_changed="current_changed_route" @on_change="table2_on_change" @on_input="table2_on_input"
          :hb_table_class="'hb_table_route_class2'">
          <template #toolbar>
            <el-button type="info" plain @click="createRouteDetail()" class="ml-2 iconfont icon-add-new" size="mini"> {{$t("common.new")}}
            </el-button>
          </template>
          <template #operation>
            <el-button type="primary" plain @click="checkRouteDetail" class=" iconfont icon-add-new" size="mini"> 检查工序</el-button>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="RouteDetailSaveData"
              :label="$t('common.save')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain name="one table" ref="RouteTable3" :fields="fields3" :title="table_title.title3" :show_query_container="false"
          :show_toolbar_container="true" :show_pagination_container="true" :show_toolbar_state="false" :show_date_picker="false"
          :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label" :query_button_label="query_lable"
          :isBusy="isBusyRouteOpr" :loading_width="30" :table_height_adjust="4" @state_change="state_change3" @on_change="table3_on_change"
          :show_toolbar_button="[0, 0, 0, 0, 1]" :hb_table_class="'hb_table_route_class3'">
          <template #toolbar>
            <el-button type="info" plain @click="createRouteOpr()" class="ml-2 iconfont icon-add-new" size="mini"> {{$t("common.new")}}
            </el-button>
          </template>
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="RouteOprSaveData"
              :label="$t('common.save')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>
    <!-- 工艺路线主表 -->
    <BaseModal ref="route_table1_modal" :title="route_table1_modal_title" @saveData="RouteSaveData">
      <template #modal_content>
        <el-form ref="dataForm" label-width="100px" class="demo-dataForm" style="height: 200px">
          <span v-for="(item,index) in RouteTableModel" :key="index">
            <el-col :span="18">
              <el-form-item :label="item.label" v-if="item.key=='dataAreaId'">
                <el-select size="small" v-model="item.value" filterable clearable placeholder="请选择销售公司" class="w-100">
                  <el-option v-for="(t,k) in getCompanyOptions()" :key="k" :label="t.label" :value="t.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="item.label" v-else-if="item.key != 'id' && item.key != 'ItemId' && item.key!='RouteId'">
                <el-input type="text" v-model="item.value" clearable></el-input>
              </el-form-item>
            </el-col>
          </span>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import SplitContainer3 from "../components/container/SplitContainer3";
import TableMain from "../components/table/TableMain";
import * as RouteController from "../../controllers/sd/RouteController";
import * as WrkCtrTableController from "../../controllers/base/WrkCtrTableController";
import QueryButton from "../components/base/QueryButton";
import BaseModal from "../components/modals/baseModal";
import fixedBaseData from "../../../public/js/fixedBaseData"
export default {
  components: {
    SplitContainer3,
    TableMain,
    QueryButton,
    BaseModal
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_master_process_route",
        title2: "table_detail_process_route",
        title3: "table_detail_process_route_item",
      },
      route_table1_modal_title: "",
      fields1: RouteController.fields.default,
      fields2: RouteController.fields.route_detail,
      fields3: _.cloneDeep(RouteController.fields.route_detail_opr),
      currDataAreaId: "",
      RouteSearchText: "",
      isBusy: false,
      isBusyRoute: false,
      isBusyRouteOpr: false,
      RouteTableModel: [],
      OprPriorityList: [],//优先级
      RouteTypeList: [],//工艺路线类型
    }
  },
  async created() {
    let _this = this
    let unIncludsFields = ["is_approved", "approved_by_username", "create_at", "create_by_username", "NameAlias"]
    let fields = _.filter(this.fields1, (t) => {
      if (!_.includes(unIncludsFields, t.key)) {
        return t;
      }
    })
    this.RouteTableModel = _.map(fields, (t) => {
      let m = {
        key: t.key,
        label: t.label,
        value: "",
        dataType: "input",
        seq: 0
      }
      return m
    })
    this.RouteTableModel = _.orderBy(this.RouteTableModel, ["seq"], ["asc"])



    let _field1 = _.find(this.fields2, {
      key: "TEC_RouteType",
    });
    _field1["_options"] = {
      provider: (v) => {
        let _lt = _.filter(_this.$store.state.biz_data.baseData.RouteType, { dataAreaId: _this.currDataAreaId });
        return _.map(_lt, (t) => {
          return {
            value: t.RouteType,
            label: t.Name,
          };
        });
      },
    };
    _field1 = _.find(this.fields2, {
      key: "TEC_ProductParts",
    });
    _field1["_options"] = {
      provider: (v) => {
        let _lt = _.filter(_this.$store.state.biz_data.baseData.ProductPartsTBL, { dataAreaId: _this.currDataAreaId });
        return _.map(_lt, (t) => {
          return {
            value: t.ProductParts,
            label: t.ProductParts,
          };
        });
      },
    };

    _field1 = _.find(this.fields2, {
      key: "OprPriority",
    });
    _field1["_options"] = {
      provider: (v) => {
        return _.map(this.OprPriorityList, (t) => {
          return { value: t.label, label: t.label }
        });
      },
    };

    this.fields3 = _.filter(this.fields3, (t) => {
      return t.key != "PerWorkerPrice" && t.key != "ElectricityPrices"
    })

    let _field2 = _.find(this.fields3, {
      key: "RouteType",
    });
    _field2["_options"] = {
      provider: (v) => {
        return _.map(this.RouteTypeList, (t) => {
          return { value: t.label, label: t.label }
        });
      },
    };

    _field2 = _.find(this.fields3, {
      key: "WrkCtrTable_RecId",
    });
    _field2["_options"] = {
      provider: (v) => {
        let _lt = _.filter(this.$store.state.biz_data.baseData.WrkCtrTable, { dataAreaId: _this.currDataAreaId });
        return _.map(_lt, (t) => {
          return {
            value: t.RecId,
            label: t.WrkCtrId,
          }; //VariantName
        });
      },
    };

  },
  mounted() {
    this.OprPriorityList = fixedBaseData.OprPriority
    this.RouteTypeList = fixedBaseData.RouteType

  },
  methods: {
    getCompanyOptions() {
      return _.map(this.$store.state.biz_data.baseData.CompanyInfo, (v) => {
        return {
          value: v.DataArea,
          label:
            v.DataArea + ":" + (v.CompanyName == null ? "" : v.CompanyName),
        };
      });
    },
    //#region 查询
    async on_query(set_data) {
      this.RouteSearchText = _.trim(this.RouteSearchText)
      this.isBusy = true;
      set_data([]);
      let p = { is_deleted: 0 }
      if (this.RouteSearchText != "") {
        p.SearchText = this.RouteSearchText
      }
      let _result = await RouteController.methods.getData(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["id"], ["desc"]));
      }
      this.isBusy = false;
    },
    async on_query_route(RouteId, isLoading = true) {
      if (isLoading) {
        this.isBusyRoute = true;
        this.$refs.RouteTable2.SetData([]);
      }
      let p = { is_deleted: { "=": 0 }, RouteId: { "=": RouteId } }
      let _result = await RouteController.methods.getDataRoute(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.RouteTable2.SetData(_.orderBy(_result[0], ["OprNum"], ["asc"]));
      }
      this.isBusyRoute = false;
    },
    async on_query_route_opr(OprId, RouteId, isLoading = true) {
      if (isLoading) {
        this.isBusyRouteOpr = true;
        this.$refs.RouteTable3.SetData([]);
      }
      let p = { is_deleted: { "=": 0 }, RouteRelation: { "=": RouteId }, OprId: { "=": OprId } }
      let _result = await RouteController.methods.getDataRouteOpr(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.RouteTable3.SetData(_.orderBy(_result[0], ["id"], ["asc"]));
      }
      this.isBusyRouteOpr = false;
    },
    //#endregion

    //#region 保存、编辑
    createRoute() {
      this.route_table1_modal_title = "新建工艺主档";
      _.each(this.RouteTableModel, (t) => {
        switch (t.key) {
          default: t.value = ""
        }
      });
      this.$refs.route_table1_modal.show()
    },
    on_cell_click_route_table1(data) {
      if (data.item.is_approved) {
        this.msgToasts("已审批或已启用数据不能被变更！", "info");
        return;
      }
      this.route_table1_modal_title = "编辑工艺主档"
      for (var k in data.item) {
        let m = _.find(this.RouteTableModel, { key: k });
        if (m) {
          m.value = data.item[k]
        }
      }
      this.$refs.route_table1_modal.show()
    },
    ///保存工艺主档
    async RouteSaveData(cb) {
      //数据验证
      let msg = "", am = {}, valid_null_list = ["Name", "dataAreaId"];
      _.each(this.RouteTableModel, (t) => {
        am[t.key] = t.value;
        if (msg == "" && valid_null_list.includes(t.key) && t.value == "") {
          msg = t.label + "不能为空！"
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info");
        cb(null);
        return;
      }

      let p = {};
      delete am.CompanyName;
      delete am.ItemId;
      delete am.NameAlias;
      if (am.id == "") {
        delete am.id;
        delete am.RouteId;
        am.RouteName = am.Name;
        delete am.Name;
        am.createBy = this.$store.state.biz_data.userInfo.user_id;
        p.add = am;
      }
      else {
        p.edit = am;
      }
      let rt = await RouteController.methods.saveDataRoute(p);
      if (rt) {
        for (var k in p) {
          if (k == "add") {
            this.$refs.RouteTable1.InsertItems(rt[0])
          }
          else if (k == "edit") {
            let tm = _.find(this.$refs.RouteTable1.my_data, { id: rt[0].id });
            if (tm) {
              Object.assign(tm, rt[0])
            }
          }
        }

        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(false);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    ///保存工艺明细
    async RouteDetailSaveData(cb) {

      let dt = this.$refs.RouteTable2.my_data;
      if (dt.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        cb(false);
        return;
      }

      let current_table1 = this.$refs.RouteTable1.GetCurrentItem();
      if (current_table1 && current_table1.is_approved) {
        this.msgToasts("已审批或已启用数据不能被变更！", "info");
        cb(false);
        return;
      }

      //数据验证
      let msg = "", diffic_msg = "";
      _.each(dt, (t) => {
        for (var k in t) {
          if (k.startsWith("_")) {
            delete t[k]
          }
          if (msg == "" && (t[k] == "" || t[k] == null)) {
            let m = _.find(this.fields2, { key: k })
            if (m && m.require && m.editable) {
              if (m.type == "number" && t[k] == 0) {
                continue
              }
              msg = "‘" + m.label + "’不能为空！"
            }
          }
        }
        if (diffic_msg == "" && parseFloat(t.TEC_DifficultyFactor) > 3) {
          diffic_msg = "难度系数超过3！"
        }
        t.TEC_DifficultyFactor = _.round(t.TEC_DifficultyFactor, 1);
        if (t.TEC_ColorNumberPositive == null) {
          t.TEC_ColorNumberPositive = 0
        }
        if (t.TEC_ColorNumberNegative == null) {
          t.TEC_ColorNumberNegative = 0
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info");
        cb(null);
        return;
      }
      if (diffic_msg != "") {
        let ask = await this.msgModal(diffic_msg + this.$t("notify.is_continue"));
        if (!ask) {
          cb(null);
          return;
        }
      }

      let p = {};
      p.add = _.map(_.filter(_.cloneDeep(dt), { id: "" }), (t) => { delete t.id; return t });
      p.edit = _.filter(_.cloneDeep(dt), (t) => { return t.id != "" });
      let rt = await RouteController.methods.saveDataRouteDetail(p);
      if (rt) {
        let current = this.$refs.RouteTable1.GetCurrentItem();
        if (current) {
          await this.on_query_route(current.RouteId, false)
        }

        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(true, true);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    ///保存工艺明细详细信息
    async RouteOprSaveData(cb) {

      let dt = this.$refs.RouteTable3.my_data;
      if (dt.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        cb(false);
        return;
      }

      let current_table1 = this.$refs.RouteTable1.GetCurrentItem();
      if (current_table1 && current_table1.is_approved) {
        this.msgToasts("已审批或已启用数据不能被变更！", "info");
        cb(false);
        return;
      }

      //数据验证
      let msg = "";
      _.each(dt, (t) => {
        for (var k in t) {
          if (k.startsWith("_")) {
            delete t[k]
          }
          if (msg == "" && t[k] == "") {
            let m = _.find(this.fields3, { key: k })
            if (m && m.require && m.editable) {
              msg = m.label + "不能为空！"
            }
          }
        }

      })
      if (msg != "") {
        this.msgToasts(msg, "info");
        cb(null);
        return;
      }

      let p = {};
      p.add = _.map(_.filter(_.cloneDeep(dt), { id: "" }), (t) => { delete t.id; return t });
      p.edit = _.filter(_.cloneDeep(dt), (t) => { return t.id != "" });
      let rt = await RouteController.methods.saveDataRouteOpr(p);
      if (rt) {
        let current = this.$refs.RouteTable2.GetCurrentItem();
        if (current) {
          await this.on_query_route_opr(current.OprId, current.RouteId, false)
        }

        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(true, true);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    //#endregion

    //#region 状态切换
    async state_change1(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        cb(false);
        return;
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"));
      if (!ask) {
        cb(false);
        return;
      }
      let p = {};
      if (data.state == "approved" || data.state == "unapproved") {
        let dt = _.each(_.cloneDeep(data.selected_items), (t) => { t.is_approved = data.state == "approved"; });
        p.approved = dt;
        if (data.state == "approved") {
          let check_m = await RouteController.methods.checkRouteAction({ type: "approved", data: dt });
          if (!check_m.state) {
            this.msgToasts("工艺路线未完成，不能被审核！编号：" + _.join(check_m.error_nums, ","), "info");
            cb(false);
            return;
          }
        }
        _.each(data.selected_items, (t) => { t.is_approved = data.state == "approved"; });
      }
      else if (data.state == "deleted") {
        let is_approved = _.some(data.selected_items, ["is_approved", true]);
        if (is_approved) {
          this.msgToasts("已审批或已启用数据不能被删除！", "info");
          cb(false);
          return;
        }
        p.delete = data.selected_items;
      }

      let rt = await RouteController.methods.saveDataRoute(p);
      if (rt) {
        if (data.state == "deleted")
          this.$refs.RouteTable1.RemoveItems(rt[0])
        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(true);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    async state_change2(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        cb(false);
        return;
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"));
      if (!ask) {
        cb(false);
        return;
      }
      let current_table1 = this.$refs.RouteTable1.GetCurrentItem();
      if (current_table1 && current_table1.is_approved) {
        this.msgToasts("已审批或已启用数据不能被变更！", "info");
        cb(false);
        return;
      }
      let p = {};
      p.delete = data.selected_items;
      let rt = await RouteController.methods.saveDataRouteDetail(p);
      if (rt) {
        this.$refs.RouteTable2.RemoveItems(rt[0]);
        this.$refs.RouteTable3.SetData([]);
        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(true);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    async state_change3(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        cb(false);
        return;
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"));
      if (!ask) {
        cb(false);
        return;
      }
      let current_table1 = this.$refs.RouteTable1.GetCurrentItem();
      if (current_table1 && current_table1.is_approved) {
        this.msgToasts("已审批或已启用数据不能被变更！", "info");
        cb(false);
        return;
      }
      let p = {};
      p.delete = data.selected_items;
      let rt = await RouteController.methods.saveDataRouteOpr(p);
      if (rt) {
        this.$refs.RouteTable3.RemoveItems(rt[0])
        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(true);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    //#endregion

    ///新增行
    createRouteDetail() {
      let m = {};
      let current = this.$refs.RouteTable1.GetCurrentItem();
      if (current) {
        _.each(this.fields2, (t) => {
          m.RouteId = current.RouteId;
          switch (t.key) {
            case "TEC_PartsCoefficient": m[t.key] = 1; break;
            case "TEC_VariantParameters": m[t.key] = 1; break;//变化参数
            case "TEC_AccuVariantParameters": m[t.key] = 1; break;//累计变化参数
            case "TEC_DifficultyFactor": m[t.key] = 1; break;//难度系数
            case "TEC_WorkTime": m[t.key] = 1; break;//工作次数
            case "TEC_ColorNumber": m[t.key] = 1; break;//色组数
            default: m[t.key] = ""
          }
        })

        this.$refs.RouteTable2.AppendItems(m)
      }
    },
    createRouteOpr() {
      let m = {};
      let current1 = this.$refs.RouteTable1.GetCurrentItem();
      let current = this.$refs.RouteTable2.GetCurrentItem();
      if (current) {
        if (this.$refs.RouteTable3.my_data.length > 0) {
          return
        }
        //电价
        let ep = 0;
        let epm = _.find(this.$store.state.biz_data.baseData.ElectricityPrices, { dataAreaId: current1.dataAreaId })
        if (epm) {
          ep = epm.ElectricityPrices
        }
        _.each(this.fields3, (t) => {
          m["RouteRelation"] = current.RouteId;
          switch (t.key) {
            case "OprId": m[t.key] = current.OprId; break;
            case "RouteType": m[t.key] = "标准"; break;//工艺路线类型
            case "ElectricityPrices": m[t.key] = ep; break;//电价
            case "ToHours": m[t.key] = 1; break;//小时/时间
            case "SiteId": m[t.key] = 1; break;//站点
            default: m[t.key] = ""
          }
        })
        this.$refs.RouteTable3.AppendItems(m)
      }
    },

    //行点击
    async current_changed(old, current) {
      this.$refs.RouteTable3.SetData([]);
      if (current) {
        this.currDataAreaId = current.dataAreaId;

        await this.on_query_route(current.RouteId)
      }
    },
    current_changed_route(old, current) {
      if (current) {
        this.on_query_route_opr(current.OprId, current.RouteId)
      }
    },
    table2_on_input(data) {
      if (data.field.key == "TEC_ColorPositive" || data.field.key == "TEC_ColorNegative") {
        if (data.item.TEC_ColorPositive != "" && data.item.TEC_ColorPositive != null)
          data.item.TEC_ColorNumberPositive = data.item.TEC_ColorPositive.split("+").length;
        else
          data.item.TEC_ColorNumberPositive = 0
        if (data.item.TEC_ColorNegative != "" && data.item.TEC_ColorNegative != null)
          data.item.TEC_ColorNumberNegative = data.item.TEC_ColorNegative.split("+").length;
        else
          data.item.TEC_ColorNumberNegative = 0
        let num = parseInt(data.item.TEC_ColorNumberPositive), num1 = parseInt(data.item.TEC_ColorNumberNegative);
        if (num == 0 && num1 == 0)
          data.item.TEC_ColorNumber = 1;
        else
          data.item.TEC_ColorNumber = num + num1;
      }
      else if (data.field.key == "TEC_VariantParameters") {
        let dt = _.orderBy(this.$refs.RouteTable2.my_data, ["_id"], ["desc"]);
        for (var i in dt) {
          let upm_data = _.filter(dt, { OprNumNext: dt[i].OprNum });
          for (var k in upm_data) {
            upm_data[k].TEC_AccuVariantParameters = upm_data[k].TEC_VariantParameters * dt[i].TEC_AccuVariantParameters;
          }
        }
      }
    },
    table2_on_change: _.debounce(
      function (data) {
        if (data.field.key == "TEC_ProductParts" || data.field.key == "TEC_RouteType") {
          data.item.OprId = data.item.TEC_ProductParts + "_" + data.item.TEC_RouteType;

          {
            let dt = _.orderBy(this.$refs.RouteTable2.my_data, ["_id"], ["desc"]);
            for (var i in dt) {
              let upm_data = _.filter(dt, { OprNumNext: dt[i].OprNum });
              for (var k in upm_data) {
                upm_data[k].TEC_AccuVariantParameters = upm_data[k].TEC_VariantParameters * dt[i].TEC_AccuVariantParameters;
              }
            }
          }
        }
      },
      200,
      { leading: false, trailing: true }
    ),
    table3_on_change: _.debounce(
      async function (data) {
        ///获取资源信息
        if (data.field.key == "WrkCtrTable_RecId") {
          let wrkCtrItem = await WrkCtrTableController.methods.getData({ RecId: data.item.WrkCtrTable_RecId });
          let m = wrkCtrItem[0][0];
          data.item.ProcessPerQty = m.ProcessPerQty;
          data.item.StandardWorkHours = _.round(3600 / m.ProcessPerQty, 2);
          data.item.UPH = m.ProcessPerQty;
          data.item.SEI_WorkerCountRate = "100%";
          data.item.SEI_WorkerCount1 = m.SEI_WorkerCount1;
          data.item.SEI_WorkerCount = m.SEI_WorkerCount1;
          data.item.SEI_UPPH = m.SEI_WorkerCount1 != 0 ? _.round(m.ProcessPerQty / m.SEI_WorkerCount1, 6) : 0;
          data.item.SetupTime = m.SetupTime;
          data.item.ProcessTime = m.ProcessTime;
          data.item.TEC_EquipPower = m.TEC_EquipPower;
          data.item.TEC_ProcessPerQty = m.TEC_ProcessPerQty;
          data.item.SetUpCategoryId = m.SetUpCategoryId;
          data.item.ProcessCategoryId = m.ProcessCategoryId;
          data.item.PerWorkerPrice = m.PerWorkerPrice;
          data.item.WrkCtrIdCost = m.WrkCtrId;
          //电价
          let current = this.$refs.RouteTable1.GetCurrentItem();
          let ep = 0;
          let epm = _.find(this.$store.state.biz_data.baseData.ElectricityPrices, { dataAreaId: current.dataAreaId })
          if (epm) {
            ep = epm.ElectricityPrices
          }
          data.item.ElectricityPrices = ep;
        }
        else if (data.field.key == "UPH") {
          data.item.SEI_WorkerCountRate = _.round(data.item.UPH * 100 / data.item.ProcessPerQty, 2) + "%"
        }
        else if (data.field.key == "SEI_WorkerCount") {
          data.item.SEI_UPPH = _.round(data.item.ProcessPerQty / data.item.SEI_WorkerCount, 6);
        }
      },
      200,
      { leading: false, trailing: true }
    ),
    checkRouteDetail() {
      let error_oprnum = [];
      let dt = this.$refs.RouteTable2.my_data;
      if (dt.length == 0) return;
      _.each(dt, (t) => {
        let m = _.find(dt, { OprNum: t.OprNumNext })
        if (t.OprNumNext > 0 && !m) error_oprnum.push(t.OprNum)
      })
      if (error_oprnum.length > 0)
        this.msgToasts(_.join(error_oprnum, ",") + "，工序编号下一个工序不存在！", "info");
      else
        this.msgToasts("恭喜通过检查！", "success");
    },
  },
}
</script>
<style>
.hb_table_route_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 75rem;
}
.hb_table_route_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 250rem;
}

.hb_table_route_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 165rem;
}
</style>
